import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container-9" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "sm:col-span-1" }, "   ", -1)
const _hoisted_3 = { class: "sm:col-span-4 main-content" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "w-64 justify-items-stretch flex flex-col mb-4" }
const _hoisted_6 = ["value", "selected"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackNextButtons = _resolveComponent("BackNextButtons")!
  const _component_ScreenWrapper = _resolveComponent("ScreenWrapper")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["screen-content", _ctx.config.wrapperClasses])
  }, [
    _createVNode(_component_ScreenWrapper, {
      "class-name": "pt-0",
      next: _ctx.next,
      screen: _ctx.screen,
      "hide-arrow": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", {
              class: "mt-8 mb-8",
              innerHTML: _ctx.$t(_ctx.config.question, {name: _ctx.state.nickname.value})
            }, null, 8, _hoisted_4),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("select", {
                class: "answer-button mb-4",
                onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.answer($event.target.value)))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (label, code) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: code,
                    key: code,
                    selected: _ctx.selected === code
                  }, _toDisplayString(label), 9, _hoisted_6))
                }), 128))
              ], 32)
            ]),
            _createVNode(_component_BackNextButtons, {
              "go-to": _ctx.goTo,
              "next-screen": _ctx.config.screenNext
            }, null, 8, ["go-to", "next-screen"])
          ]),
          _createElementVNode("div", {
            class: "sm:col-span-4 h-full min-h-50vh",
            style: _normalizeStyle(`background:  ${_ctx.config.bgImage} center right; background-size: contain; background-repeat: no-repeat; ${_ctx.config.bgStyles}`)
          }, "   ", 4)
        ])
      ]),
      _: 1
    }, 8, ["next", "screen"])
  ], 2))
}